import { useState } from "react";
import { Facebook, Linkedin, Link2, MessageCircle, Send, Twitter, Check } from "lucide-react";

export const ShareButtons = ({ url, title }) => {
  const [copied, setCopied] = useState(false);
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  const items = [
    { key: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${t}%20${u}`, color: "#25D366" },
    { key: "telegram", icon: Send, href: `https://t.me/share/url?url=${u}&text=${t}`, color: "#229ED9" },
    { key: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, color: "#1877F2" },
    { key: "x", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, color: "#e5e5e5" },
    { key: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, color: "#0A66C2" },
  ];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copy this link", url);
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="mr-1 text-xs uppercase tracking-widest text-zinc-500">Share</span>
      {items.map((i) => (
        <a key={i.key} href={i.href} target="_blank" rel="noreferrer" aria-label={`Share on ${i.key}`} data-testid={`share-${i.key}`}
          className="grid h-10 w-10 place-items-center rounded-full border border-[#D4AF37]/30 transition-colors hover:border-[#D4AF37] hover:bg-[#D4AF37]/10">
          <i.icon size={16} style={{ color: i.color }} />
        </a>
      ))}
      <button onClick={copy} data-testid="share-copy" aria-label="Copy link"
        className="grid h-10 w-10 place-items-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] transition-colors hover:border-[#D4AF37]">
        {copied ? <Check size={16} /> : <Link2 size={16} />}
      </button>
    </div>
  );
};
